import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import("@/pages/login/Login.vue"),
    },
    {
        path: '/home',
        name: "主页",
        meta: {requireAuth: true},
        component: () => import("@/pages/home/Home.vue"),
        children: [
            {
                path: '/home/workbench',
                meta: {requireAuth: true},
                name: "工作台",
                component: () => import('@/pages/home/Workbench.vue')
            },
            {
                path: '/platform',
                name: "药房管理",
                meta: {requireAuth: true},
                component: () => import('@/pages/platform/index'),
                children: [
                    {
                        path: '/platform/permissions',
                        name: "用户组权限管理",
                        component: () => import('@/pages/platform/permissions/permissions'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/user',
                        name: "用户管理",
                        component: () => import('@/pages/platform/user/user'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/workers',
                        name: "售后工人管理",
                        component: () => import('@/pages/platform/workers/workers'),
                        meta: {requireAuth: true},
                    },
                    {
                        path: '/platform/role',
                        name: "角色管理",
                        component: () => import('@/pages/platform/role/role'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/operator',
                        name: "代理商管理",
                        component: () => import('@/pages/platform/operator/operator'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/operatorUser',
                        name: "代理商用户管理",
                        component: () => import('@/pages/platform/operator/operatorUser'),
                        meta: {requireAuth: true},
                    },  {
                        path: '/platform/hostingPharmacy',
                        name: "拖管药房",
                        component: () => import('@/pages/platform/operator/hostingPharmacy'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/drug',
                        name: "药品管理",
                        component: () => import('@/pages/platform/drug/drug'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/region',
                        name: "地区管理",
                        component: () => import('@/pages/platform/region/region'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/manufacturer',
                        name: "厂家管理",
                        component: () => import('@/pages/platform/manufacturer/manufacturer'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/drugCup',
                        name: "药杯管理",
                        component: () => import('@/pages/platform/drugCup/drugCup'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/remedy',
                        name: "药品类型管理",
                        component: () => import('@/pages/platform/remedy/remedy'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/server',
                        name: "服务器管理",
                        component: () => import('@/pages/platform/server/server'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/database',
                        name: "数据库管理",
                        component: () => import('@/pages/platform/database/database'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/drugData',
                        name: "药房数据库管理",
                        component: () => import('@/pages/platform/database/drugData'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/equipment',
                        name: "设备管理",
                        component: () => import('@/pages/platform/equipment/equipment'),
                        meta: {requireAuth: true,keepAlive:true},
                    }, {
                        path: '/platform/deviceMaintain',
                        name: "设备维护管理",
                        component: () => import('@/pages/platform/deviceMaintain/deviceMaintain'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/deviceType',
                        name: "设备类型管理",
                        component: () => import('@/pages/platform/deviceType/deviceType'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/drugInfo',
                        name: "药品信息管理",
                        component: () => import('@/pages/platform/drugInfo/drugInfo'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/exceptionRecord',
                        name: "异常记录",
                        component: () => import('@/pages/platform/exceptionRecord/exceptionRecord'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/medicalInstitution',
                        name: "",
                        component: () => import('@/pages/platform/medicalInstitution/medicalInstitution'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/drugSafeRemianConfig',
                        name: "",
                        component: () => import('@/pages/platform/drugSafeRemianConfig/drugSafeRemianConfig'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/maintenanceTypes',
                        name: "设备维护类型管理",
                        component: () => import('@/pages/platform/maintenanceTypes/maintenanceTypes'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/maintainTemplate',
                        name: "维护模板",
                        component: () => import('@/pages/platform/maintainTemplate/maintainTemplate'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/platform/exceptionHandling',
                        name: "异常处理",
                        component: () => import('@/pages/platform/exceptionHandling/exceptionHandling'),
                        meta: {requireAuth: true},
                    },
                    {
                        path: '/platform/parttypes',
                        name: "零件类型",
                        component: () => import('@/pages/platform/parttypes/parttypes'),
                        meta: {requireAuth: true},
                    },
                    {
                        path: '/platform/areamanager',
                        name: "区域售后负责人",
                        component: () => import('@/pages/platform/areamanager/areamanager'),
                        meta: {requireAuth: true},
                    },
                ]
            },
            {
                path: '/recipeStatistics',
                name: "数据分析",
                component: () => import('@/pages/recipeStatistics/index'),
                children: [
                    {
                        path: '/recipeStatistics/salesChart',
                        component: () => import('@/pages/recipeStatistics/recipeList/salesChart'),
                        meta: {requireAuth: true},
                    },
                    {
                        path: '/recipeStatistics/anomaly',
                        component: () => import('@/pages/recipeStatistics/anomaly/index'),
                        children: [
                            {
                                path: '/recipeStatistics/anomaly/anomaly',
                                component: () => import('@/pages/recipeStatistics/anomaly/anomaly'),
                            }, {
                                path: '/recipeStatistics/anomaly/operator',
                                component: () => import('@/pages/recipeStatistics/anomaly/operator'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                            {
                                path: '/recipeStatistics/anomaly/abnormalSum',
                                component: () => import('@/pages/recipeStatistics/anomaly/abnormalSum'),
                                meta: {requireAuth: true,keepAlive:true},
                            }, {
                                path: '/recipeStatistics/anomaly/maintenance',
                                component: () => import('@/pages/recipeStatistics/anomaly/maintenance'),
                                meta: {requireAuth: true,keepAlive:true},
                            }, {
                                path: '/recipeStatistics/anomaly/devicesSum',
                                component: () => import('@/pages/recipeStatistics/anomaly/devicesSum'),
                                meta: {requireAuth: true,keepAlive:true},
                            }, {
                                path: '/recipeStatistics/anomaly/evaluationType',
                                component: () => import('@/pages/recipeStatistics/anomaly/evaluationType'),
                                meta: {requireAuth: true,keepAlive:true},
                            }, {
                                path: '/recipeStatistics/anomaly/maintenanceEvaluation',
                                component: () => import('@/pages/recipeStatistics/anomaly/maintenanceEvaluation'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                        ],
                        meta: {requireAuth: true},
                    },
                    {
                        path: '/recipeStatistics/consumables',
                        component: () => import('@/pages/recipeStatistics/consumables/index'),
                        meta: {requireAuth: true},
                        children: [
                            {
                                path: '/recipeStatistics/consumables/cupsExpendChart',
                                component: () => import('@/pages/recipeStatistics/consumables/cupsExpendChart'),
                                meta: {requireAuth: true,keepAlive:true},
                            }, {
                                path: '/recipeStatistics/consumables/cupsExpend',
                                component: () => import('@/pages/recipeStatistics/consumables/cupsExpend'),
                                meta: {requireAuth: true,keepAlive:true},
                            }, {
                                path: '/recipeStatistics/consumables/operator',
                                component: () => import('@/pages/recipeStatistics/consumables/operator'),
                                meta: {requireAuth: true,keepAlive:true},
                            }, {
                                path: '/recipeStatistics/consumables/pharmacy',
                                component: () => import('@/pages/recipeStatistics/consumables/pharmacy'),
                                meta: {requireAuth: true,keepAlive:true},
                            }, {
                                path: '/recipeStatistics/consumables/equipment',
                                component: () => import('@/pages/recipeStatistics/consumables/equipment'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                        ]
                    },
                    {
                        path: '/recipeStatistics/drugDosage',
                        component: () => import('@/pages/recipeStatistics/drugDosage/index'),
                        meta: {requireAuth: true},
                        children: [
                            {
                                path: '/recipeStatistics/drugDosage/operator',
                                component: () => import('@/pages/recipeStatistics/drugDosage/operator'),
                            }, {
                                path: '/recipeStatistics/drugDosage/pharmacy',
                                component: () => import('@/pages/recipeStatistics/drugDosage/pharmacy'),
                            }, {
                                path: '/recipeStatistics/drugDosage/equipment',
                                component: () => import('@/pages/recipeStatistics/drugDosage/equipment'),
                            },
                        ]
                    },
                    {
                        path: '/recipeStatistics/prescriptionAnalysis',
                        component: () => import('@/pages/recipeStatistics/prescriptionAnalysis/index'),
                        meta: {requireAuth: true},
                        children: [
                            {
                                path: '/recipeStatistics/prescriptionAnalysis/operator',
                                component: () => import('@/pages/recipeStatistics/prescriptionAnalysis/operator'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                            {
                                path: '/recipeStatistics/prescriptionAnalysis/workload',
                                name:'人员工作量分析',
                                component: () => import('@/pages/recipeStatistics/prescriptionAnalysis/workload'),
                                meta: {requireAuth: true,keepAlive:true},
                            },  {
                                path: '/recipeStatistics/prescriptionAnalysis/equipment',
                                name:'设备工作量分析',
                                component: () => import('@/pages/recipeStatistics/prescriptionAnalysis/equipment'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                            {
                                path: '/recipeStatistics/prescriptionAnalysis/prescriptionData',
                                component: () => import('@/pages/recipeStatistics/prescriptionAnalysis/prescriptionData'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                        ]
                    },
                    {
                        path: '/recipeStatistics/cupProduction/cupProduction',
                        name:'药杯生产指导计划',
                        component: () => import('@/pages/recipeStatistics/cupProduction/cupProduction'),
                    },
                    {
                        path: '/recipeStatistics/abnormal',
                        component: () => import('@/pages/recipeStatistics/abnormal/index'),
                        meta: {requireAuth: true},
                        children: [
                            {
                                path: '/recipeStatistics/abnormal/abnormal',
                                name:'异常分析',
                                component: () => import('@/pages/recipeStatistics/abnormal/abnormal'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                            {
                                path: '/recipeStatistics/abnormal/model',
                                name:'型号',
                                component: () => import('@/pages/recipeStatistics/abnormal/model'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                        ]
                    },
                    {
                        path: '/recipeStatistics/drugInventory',
                        component: () => import('@/pages/recipeStatistics/drugInventory/index'),
                        meta: {requireAuth: true},
                        children: [
                            {
                                path: '/recipeStatistics/drugInventory/stocks',
                                component: () => import('@/pages/recipeStatistics/drugInventory/stocks'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                            {
                                path: '/recipeStatistics/drugInventory/stockUp',
                                component: () => import('@/pages/recipeStatistics/drugInventory/stockUp'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                        ]
                    },
                    {
                        path: '/recipeStatistics/satisfaction',
                        component: () => import('@/pages/recipeStatistics/satisfaction/index'),
                        meta: {requireAuth: true},
                        children: [
                            {
                                path: '/recipeStatistics/satisfaction/service',
                                component: () => import('@/pages/recipeStatistics/satisfaction/service'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                            {
                                path: '/recipeStatistics/satisfaction/maintenance',
                                component: () => import('@/pages/recipeStatistics/satisfaction/maintenance'),
                                meta: {requireAuth: true,keepAlive:true},
                            }, {
                                path: '/recipeStatistics/satisfaction/afterSales',
                                component: () => import('@/pages/recipeStatistics/satisfaction/afterSales'),
                                meta: {requireAuth: true,keepAlive:true},
                            }, {
                                path: '/recipeStatistics/satisfaction/annualStaff',
                                component: () => import('@/pages/recipeStatistics/satisfaction/annualStaff'),
                                meta: {requireAuth: true,keepAlive:true},
                            },
                        ]
                    },
                    {
                        path: '/notice/notice',
                        component: () => import('@/pages/notice/notice'),
                        meta: {requireAuth: true},
                    }, {
                        path: '/setting/setting',
                        component: () => import('@/pages/setting/setting'),
                        meta: {requireAuth: true},
                    },
                ]
            }
        ]
    },
    {
        path: '/dataKanban',
        name: '数据看板',
        component: () => import("@/pages/home/dataKanban.vue"),
    },
    {
        path: '*',
        name: 'notFond',
        component: () => import("@/pages/notFond/notFond.vue"),
    },
]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
})
// 设置路由拦截
router.beforeEach((to, from, next) => {
    let token = window.utils.storage.getter('headerToken')
    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
        if (token) { // 通过vuex state获取当前的token是否存在
            next()
        } else {
            next({
                path: '/',
            })
        }
    } else {
        next()
    }
})

export default router